import { Routes, Route } from "react-router-dom";

import ProtectedRoute from "../utils/ProtectedRoute";
import AppLayout from "../layouts/AppLayout";

import LoginPage from "../pages/LoginPage/LoginPage";
import SignupPage from "../pages/SignupPage/SignupPage";
import BrokerSelectionPage from "../pages/BrokerSelectionPage/BrokerSelectionPage";
import UnAuthorizedPage from "../pages/UnAuthorizedPage";
import NotFoundPage from "../pages/NotFoundPage/NotFoundPage";

import { getRoutableRoutes } from "./routesConfig";

function AppRoutes() {
  const routableRoutes = getRoutableRoutes();

  return (
    <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/select-broker" element={<BrokerSelectionPage />} />
        <Route element={<AppLayout />}>
          {routableRoutes.map((route) => {
            const RouteComponent = route.component;
            return (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <ProtectedRoute allowedRoles={route.roles}>
                    <RouteComponent />
                  </ProtectedRoute>
                }
              />
            );
          })}
          <Route
            path="*"
            element={
              <ProtectedRoute>
                <NotFoundPage />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route path="/un-authorized" element={<UnAuthorizedPage />} />
      </Routes>
  );
}

export default AppRoutes;
